/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'moment';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { weeksAndDays } from 'utils/durations';
import * as statuses from 'utils/statuses';
import { ElectroTooltip } from 'components/ExtendedUiElements/customized';

@translate()
@inject('assetStore')
@observer
export default class ContractDetails extends React.Component<*> {
  renderContractClosedDateRow() {
    const {
      t,
      assetStore: {
        asset: { contract },
      },
    } = this.props;

    const contractStatusCode = statuses.getCode(contract.er_status);
    if (contractStatusCode === 'closed' && contract.er_end_date) {
      return (
        <tr>
          <td>
            <b>{t('general:contracts.labels.closed_date')}:</b>
          </td>
          <td>{moment(contract.er_end_date).format('MMMM DD, YYYY')}</td>
        </tr>
      );
    }
  }

  render() {
    const {
      t,
      i18n,
      assetStore: { asset },
    } = this.props;

    const { contract } = asset;
    const isSold = statuses.getCode(asset.status) === 'sold';

    return (
      <div>
        <h3>{t('general:contracts.labels.details')}</h3>
        <table>
          <tbody>
            <tr>
              <td>
                <b>{t('general:trading_accounts.labels.number')}:</b>
              </td>
              <td>{contract.account.account_no}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:labels.company_name')}:</b>
              </td>
              <td>{contract.company_name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:contracts.labels.number')}:</b>
              </td>
              <td>{contract.er_contract_number}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:contracts.labels.status')}:</b>
              </td>
              <td>{statuses.translate(contract.er_status, i18n)}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:contracts.labels.po_number')}:</b>
              </td>
              <td>{contract.er_po_number}</td>
            </tr>
            <tr>
              <ElectroTooltip
                classes={{
                  arrowPopper: 'contractStartDateTooltip',
                }}
                title={t('general:contracts.labels.first_shipment_date')}
              >
                <td>
                  <b>{t('general:contracts.labels.start_date')}:</b>
                </td>
              </ElectroTooltip>
              <td>
                {contract.er_start_date && moment(contract.er_start_date).format('MMMM DD, YYYY')}
              </td>
            </tr>
            {!isSold && (
              <tr>
                <td>
                  <b>{t('general:contracts.labels.expected_end_date')}:</b>
                </td>
                <td>
                  {contract.er_expected_end_date &&
                    moment(contract.er_expected_end_date).format('MMMM DD, YYYY')}
                </td>
              </tr>
            )}
            {contract.er_expected_end_date && contract.er_start_date && (
              <tr>
                <td>
                  <b>{t('general:contracts.labels.duration')}:</b>
                </td>
                <td>{weeksAndDays(contract.er_start_date, contract.er_expected_end_date, t)}</td>
              </tr>
            )}
            <tr>
              <td>
                <b>{t('general:contracts.labels.contact')}:</b>
              </td>
              <td>{contract.er_contact_name}</td>
            </tr>
            <tr>
              <td>
                <b>{t('general:contracts.labels.email')}:</b>
              </td>
              <td>{contract.er_contact_email}</td>
            </tr>

            {this.renderContractClosedDateRow()}
          </tbody>
        </table>
        <Link to={'/orders/' + contract.id}>
          <Button variant="contained" color="primary">
            {t('general:actions.view_details')}
          </Button>
        </Link>
      </div>
    );
  }
}
